import { Injectable } from "@angular/core";
import { ApiService } from "@services/api.service";
import { Prestador } from "@models/prestador.model";
import { assignToModel } from "@shared/utils/fieldsMap.utils";
import { DangerError } from "@shared/errors/custom.error";
import { IResponseAPIObjeto } from "@models/responseAPI.interface";
import { SessionService } from "./session.service";
import { environment } from "@env/environment";

@Injectable({
  providedIn: "root",
})
export class PrestadorService {
    rutSinDV: number; // Rut del usuario sin su digito verificador
    private env = environment.env;

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService
    ) {
        this.rutSinDV = this.sessionService.getSesionActual().getRutSinDV();
    }

  async obtenerInformacion(rut: number) {
    const { data, msg, success } =
      await this.apiService.privatePost<IResponseAPIObjeto>(
        `lectura-prestador`,
        {
          rut,
        }
      );

    if (!success || !data) throw new DangerError(msg);
    const datos = structuredClone(data) as any;
    datos.comuna = {
      nombre: data.comuna
    }
    return assignToModel(Prestador, datos, {
      dv: "digver",
    });
  }

  async actualizarEmail(rut: number, email: string) {
    const { msg, success } =
      await this.apiService.privatePatch<IResponseAPIObjeto>(
        `modificacion-correo-prestador`,
        {
          rut,
          email,
        }
      );
    if (!success) throw new DangerError(msg);
    return msg;
  }
}
